import { orderApi } from "./order.api";

export const {
  useGetOrdersQuery,
  useLazyGetOrdersQuery,
  useListOrdersInfiniteQuery,
  useGetOrderHasDriverQuery,
  useLazyGetOrderHasDriverQuery,
  useCreateOrderMutation,
  useSaveOrderMutation,
  useDeleteOrderMutation,
  useSearchOrdersQuery,
  useLazySearchOrdersQuery
} = orderApi;
